// src/editor.ts
var getEditors = (client, provider) => async (options) => {
  return await client.get(`${provider}/editors`, options).json();
};
var getEditor = (client, provider) => async (id, options) => {
  return await client.get(`${provider}/editors/${id}`, options).json();
};
var createEditor = (client, provider) => async (data, options) => {
  return await client.post(`${provider}/editors`, { json: data, ...options }).json();
};
var updateEditor = (client, provider) => async (id, data, options) => {
  return await client.patch(`${provider}/editors/${id}`, { json: data, ...options }).json();
};
var createEditorApi = (client, provider) => {
  return {
    getEditors: getEditors(client, provider),
    getEditor: getEditor(client, provider),
    createEditor: createEditor(client, provider),
    updateEditor: updateEditor(client, provider)
  };
};

export {
  createEditorApi
};
